// Phase name → CSS variable lookup for gate-aware primitives (PhasePill, etc.).
// Keys match the gate_name values used by apm/app/services/gates.py:GATE_DEFS,
// since project.status equals the current gate name.

export const PHASE_VAR: Record<string, string> = {
  Intake: '--apm-phase-intake',
  Design: '--apm-phase-design',
  'IT Review': '--apm-phase-it',
  'Security Review': '--apm-phase-sec',
  'HIPAA/PII Review': '--apm-phase-hipaa',
  UAT: '--apm-phase-uat',
  'Go-Live': '--apm-phase-go',
  Active: '--apm-phase-active',
  Archived: '--apm-phase-arch',
  // Legacy / future phases retained for forward-compat.
  'Cost & Ops': '--apm-phase-cost',
  'RA/QA': '--apm-phase-raqa',
  'Support & Maint': '--apm-phase-active',
};

export type PhaseName = keyof typeof PHASE_VAR;

export const phaseVar = (phase: string): string =>
  PHASE_VAR[phase] ?? '--apm-phase-arch';

// Canonical gate order (required = phi_only is shown only on PHI projects).
export const GATE_ORDER = [
  'Intake',
  'Design',
  'IT Review',
  'Security Review',
  'HIPAA/PII Review',
  'UAT',
  'Go-Live',
  'Active',
  'Archived',
] as const;

export type GateName = (typeof GATE_ORDER)[number];

export const GATE_OUTCOMES = [
  'Approved',
  'Approved with conditions',
  'Blocked',
] as const;
export type GateOutcome = (typeof GATE_OUTCOMES)[number];
